import { render, staticRenderFns } from "./OtherServices.vue?vue&type=template&id=4ef4f3d7&scoped=true"
import script from "./OtherServices.vue?vue&type=script&lang=js"
export * from "./OtherServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef4f3d7",
  null
  
)

export default component.exports